/** Opmaak voor het Beroepsregistratiecertificaat (cockpitkaart + publieke verificatiepagina). */
export const fmtGetal = (n: number) => n.toLocaleString('nl-NL', { maximumFractionDigits: 2 });
export const fmtDag = (iso: string) =>
  new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
export const fmtTijdstip = (iso: string) =>
  new Date(iso).toLocaleString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

/** Kort: eerste 10 + laatste 6 tekens; volledige waarde in de title-tooltip. */
export const kort = (s: string, voor = 10, na = 6) => (s.length > voor + na + 1 ? `${s.slice(0, voor)}…${s.slice(-na)}` : s);
